var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36721_19573)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 90.8108,
    rx: 45.4054,
    fill: "#515064"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.4,
    cy: 77.5405,
    rx: 49.4,
    ry: 28.5405,
    fill: "#373643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9816 40.696C49.978 40.696 47.9629 37.612 49.1691 34.8613L55.6961 19.9767C56.9318 17.1591 54.8677 14 51.7909 14H36.8693C35.1765 14 33.6438 15.0014 32.964 16.5517L20.4914 44.9951C19.5264 47.196 21.1386 49.6634 23.5417 49.6634H34.3956C36.6055 49.6634 38.2027 51.776 37.6 53.9021L32.0803 73.3789C31.4667 75.5442 34.2844 76.974 35.6697 75.2002L56.6858 48.2883C59.0954 45.2027 56.8969 40.696 52.9816 40.696Z",
    fill: "url(#paint0_linear_36721_19573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6697 75.2002L56.6858 48.2883C59.0956 45.2027 56.8969 40.696 52.9818 40.696C49.9782 40.696 47.9632 37.612 49.1694 34.8613L55.6964 19.9767C56.9318 17.1591 54.8677 14 51.7909 14H45.9536L35.2257 39.2376C33.9757 42.1782 36.1337 45.4402 39.3289 45.4402C45.2594 45.4402 48.8766 51.9614 45.737 56.9926L33.8831 75.9885C34.5146 76.0515 35.1812 75.8258 35.6697 75.2002Z",
    fill: "url(#paint1_linear_36721_19573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.569 54.6104L72.3403 40.8687C73.4294 39.1626 72.4568 36.8957 70.4701 36.509L65.563 35.554C63.7879 35.2085 62.5741 33.5598 62.7716 31.7621L63.938 21.1402C64.1381 19.3178 61.7409 18.4732 60.7545 20.0186L52.0232 33.6975C50.9235 35.4204 51.9268 37.7078 53.9391 38.0657L58.7214 38.9162C60.5233 39.2367 61.768 40.8991 61.5683 42.7184L60.3855 53.4888C60.1854 55.3112 62.5826 56.1557 63.569 54.6104Z",
    fill: "url(#paint2_linear_36721_19573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4703 36.5091L65.5631 35.5541C63.788 35.2086 62.5742 33.5599 62.7717 31.7622L63.9381 21.1403C64.0311 20.2939 63.5636 19.6591 62.9376 19.376L58.966 31.6897C58.3088 33.727 59.3359 35.9262 61.3199 36.7301L63.602 37.6548C65.6237 38.4739 66.6452 40.7368 65.9224 42.7948L61.5269 55.3104C62.2256 55.5592 63.0746 55.3852 63.5692 54.6105L72.3405 40.8688C73.4295 39.1627 72.4569 36.8957 70.4703 36.5091Z",
    fill: "url(#paint3_linear_36721_19573)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 89,
    height: 88.8108,
    rx: 44.4054,
    stroke: "#F1BB60",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36721_19573",
    x1: 36.9036,
    y1: -2.20242,
    x2: 40.5048,
    y2: 82.4278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36721_19573",
    x1: 55.0426,
    y1: 35.8578,
    x2: 1.18915,
    y2: 69.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#F67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36721_19573",
    x1: 51.5702,
    y1: 37.3145,
    x2: 72.7934,
    y2: 37.3145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_36721_19573",
    x1: 68.2936,
    y1: 35.592,
    x2: 42.4878,
    y2: 43.8694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#F67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36721_19573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 90.8108,
    rx: 45.4054,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstant);
export default __webpack_public_path__ + "static/media/constant.20ce8114e519a9c6e9b8364132963335.svg";
export { ForwardRef as ReactComponent };